<template>
  <div class="header clear">
    <div class="head clear">
      <div class="logo ov"><img @click="goIndex" :src="webLogo" /></div>
      <div class="nav">
        <a
          v-for="(item, index) in nav"
          :key="index"
          @click.stop="path(item.path)"
        >
          {{ item.title }}
          <div
            class="select-box"
            v-show="item.name == 'preciousMetal' && isSelect2"
          >
            <div class="select" @click="jump('/preciousMetal')">
              {{ $t("langNew.yxhy") }}
            </div>
            <div class="select" @click="jump('/contractTransaction')">
              {{ $t("currency.jg") }}
            </div>
          </div>
          <div class="select-box" v-show="item.name == 'deal_jg' && isSelect">
            <div class="select" @click="jump('/deal')">
              {{ $t("currency.bb") }}
            </div>
            <div class="select" @click="jump('/deal_c')">
              {{ $t("currency.hy") }}
            </div>
            <div class="select" @click="jump('/deal_jg')">
              {{ $t("currency.jg") }}
            </div>
          </div>
        </a>
        <a v-for="(item, index) in nav3" :key="index" @click.stop="path(item.path)">{{item.title }}</a>
        <!-- <a @click="path('subscription')">{{ $t("xbsg.title") }}</a>
        <a @click="path('benefits')">{{ $t("langNew2.flzq") }}</a>
        <a @click="path('/table1')">{{ btn[2] }}</a> -->
      </div>
      <dl class="login clear">
        <dt>
          <span>{{ default_lang }}</span>
          <p>
            <a
              v-for="(item, index) in lang"
              :key="index"
              @click="setLang(index)"
              >{{ item.lang }}</a
            >
          </p>
        </dt>
        <!-- 创建虚拟账户 -->
        <dt v-show="temp_user && token">
          <a class="login-box" v-if="!isMn" @click="create">
            <span>{{ $t("langNew2.cjxnzh") }}</span>
          </a>
          <a class="login-box" v-else @click="create">
            <span>{{ $t("langNew.tcmnzh") }}</span>
          </a>
        </dt>
        <dt>
          <a class="login-box">
            <span v-if="!token" @click="!token && path('/login')">{{
              $t("login.list")[3]
            }}</span
            ><span v-else>{{ phone | mdName }}</span>
            <div class="set-box" v-show="token">
              <div
                class="set"
                v-for="(item, index) in menus"
                :key="index"
                @click.stop="path(item.path)"
              >
                {{ item.title }}
              </div>
            </div>
          </a>
        </dt>
        <dd>
          <a v-if="!token" @click="path('/register')">{{
            $t("register.register_btn")
          }}</a>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { setLang, getLang } from "@/utils/auth";
import { getLogo, getCheckcode } from "@/api/index";

export default {
  props: {
    aoStyle: {
      type: Object,
      default: () => {
        return {
          background: "#0e1837",
          // position: "absolute"
        };
      },
    },
    navName: {
      type: String,
      default: () => {
        return {
          navName,
        };
      },
    },
  },
  data() {
    return {
      btn: this.$t("nav.btn"),
      nav: this.$t("nav.nav"),
      nav2: this.$t("nav.nav2"),
      nav3: [],
      menus: this.$t("nav.menus"),
      lang: this.$t("nav.lang"),
      default_lang: "",
      logo: "",
      isSelect: false,
      isSelect2: false,
      temp_user: false,
      isMn: false
    };
  },
  computed: {
    ...mapGetters(["token", "phone"]),
  },
  created(){
    this.nav3 = [
      { title: this.$t("wydb.db"), path: "/currency",name:"currency"},
      { title: this.$t("xbsg.title"), path: "/subscription",name:"subscription"},
      { title: this.$t("langNew2.flzq"), path: "/benefits",name:"benefits"},
      { title: this.btn[2], path: "/table1",name:"assets"},
    ]
  },
  mounted() {
    this.isMn = localStorage.getItem('isMn') || false;
    var key = getLang();
    var obj = this.lang.find((o) => o.key == key);
    this.default_lang = obj.lang;
    // if (this.token) {
    //   this.nav = this.nav.concat(this.nav2);
    // }
    // this.getLogo();
    getCheckcode().then((res) => {
      if (typeof res === "string") res = JSON.parse(res);
      this.temp_user = res.temp_user;
    });
  },
  methods: {
    create() {
      if(!this.isMn){
        this.$store
        .dispatch("login2", {})
        .then(() => {
          // this.$message({
          //   type: "",
          //   message: this.$t('statusText')[2]
          // });
          this.isMn = true
          localStorage.removeItem("sbsxbz");
          localStorage.removeItem("sbsxIcon");
          this.$router.push({ path: "/index" });
          localStorage.setItem('isMn',true)
        })
        .catch(() => {})
        .finally(() => {});
      }else{
        this.$store.dispatch("FedLogOut").then(() => {
          this.isMn = false;
          localStorage.removeItem("sbsxbz");
          localStorage.removeItem("sbsxIcon");
          localStorage.removeItem("isMn");
          location.reload();
        });
      }
    },
    getLogo() {
      if(sessionStorage.getItem('web_logo')){
        this.logo = sessionStorage.getItem('web_logo')
      }else{
        getLogo({ key: "web_logo" }).then((res) => {
          sessionStorage.setItem("web_logo", res);
          this.logo = res;
        });
      }
    },
    setLang(index) {
      var key = this.lang[index].key;
      setLang(key);
      this.$i18n.locale = key;
      localStorage.setItem("lang", key);
      location.reload();
    },
    path(path) {
      if (path) {
        // if(path=='/deal_c'){
        //   localStorage.setItem('type',2)
        // }
        // if(path=='/deal'){
        //   localStorage.setItem('type',1)
        // }
        if (path == "/preciousMetal") {
          this.isSelect = false;
          this.isSelect2 = !this.isSelect2;
          localStorage.setItem("type", 3);
          return false;
        } else if (path == "/deal_jg") {
          this.isSelect2 = false;
          this.isSelect = !this.isSelect;
          localStorage.setItem("type", 3);
          return false;
        } else {
          this.$router.push({ path: path });
        }
      }else {
        this.$store.dispatch("FedLogOut").then(() => {
          this.isMn = false;
          localStorage.removeItem("sbsxbz");
          localStorage.removeItem("sbsxIcon");
          localStorage.removeItem("isMn");
          location.reload();
        });
      }
    },
    jump(path) {
      if (path == "/deal_c") {
        localStorage.setItem("type", 2);
      }
      if (path == "/deal") {
        localStorage.setItem("type", 1);
      }
      if (path == "/deal_jg") {
        localStorage.setItem("type", 3);
      }
      if (path == "/preciousMetal") {
        localStorage.setItem("type", 2);
      }
      if (path == "/contractTransaction") {
        localStorage.setItem("type", 3);
      }
      this.$router.push({ path: path });
    },
    goIndex() {
      this.$router.push("/index");
    },
  },
  filters: {
    mdName: function (str) {
      if (str.length >= 7) {
        return str.substr(0, 3) + "****" + str.substr(7, str.split("").length);
      } else {
        return str;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 50px;
  background-color: #020911;
}
.header .head {
  width: 95%;
  margin: auto;
}
.header .head .logo {
  height: 30px;
  float: left;
  margin: 10px 0;
  cursor: pointer;
}
.header .head .logo img {
  display: block;
  height: 30px;
}
.header .head .nav {
  height: 50px;
  float: left;
  margin-left: 5px;
}
.header .head .nav a {
  display: block;
  float: left;
  margin-left: 15px;
  font-size: 12px;
  line-height: 50px;
  color: #fff;
  position: relative;
}
.header .head .nav a:nth-child(3) {
  margin-right: 10px;
}
.header .head .nav a:nth-child(3)::after,
.header .head .nav a:nth-child(4)::after {
  position: absolute;
  right: -12px;
  top: 50%;
  content: "";
  width: 0;
  height: 0;
  margin-top: -2px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fff;
  border-bottom: 4px solid transparent;
}
.header .head .nav a:hover {
  color: #00d5fd;
}
.header .head .login {
  height: 50px;
  float: right;
  position: relative;
}
.header .head .login dt span {
  display: block;
  font-size: 12px;
  color: #fff;
  line-height: 50px;
  cursor: pointer;
}
.header .head .login dt p {
  display: none;
  position: absolute;
  left: 0;
  z-index: 10;
  width: 180px;
  top: 50px;
  padding: 10px 0;
  padding-top: 0;
  background-color: #020911;
  overflow: hidden;
}
.header .head .login dt p a {
  display: block;
  padding: 0 10px 0 5px;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
}
.header .head .login dt p a img {
  height: 14px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}
.header .head .login dt:hover span {
  color: #00d5fd;
}
.header .head .login dt:hover p {
  display: block;
}
.header .head .login dt {
  display: block;
  float: left;
  font-size: 14px;
  line-height: 50px;
}
.header .head .login dt > a {
  color: #fff;
  margin-left: 15px;
  display: block;
}
.header .head .login dt a:hover {
  color: #00d5fd;
}
.header .head .login dd {
  display: block;
  float: left;
  font-size: 14px;
  line-height: 30px;
  height: 30px;
  margin: 10px 0;
  margin-left: 30px;
}
.header .head .login dd a {
  display: block;
  padding: 0 30px;
  color: #333;
  background-color: #00d5fd;
  border-radius: 5px;
  overflow: hidden;
}
.select-box {
  position: absolute;
  top: 60px;
  left: 0;
  z-index: 999;
  width: 200px;
  background: #fff;
  border-radius: 2px;
}
.select-box .select {
  height: 34px;
  padding: 0 15px;
  color: #000;
  line-height: 34px;
  font-size: 14px;
  text-align: left;
}
.select-box .select:hover {
  color: #000;
  background: #eee;
}
.login-box:hover .set-box {
  display: block;
}
.set-box {
  display: none;
  width: 120px;
  position: absolute;
  right: 0;
  top: 50px;
  z-index: 10;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
}
.set-box .set {
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  overflow: hidden;
  color: #000;
  font-size: 14px;
  border-bottom: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/AoNav.vue